import { ReactNode, memo } from 'react';

interface UnifiedTopBarProps {
  subtitle?: string;
  stepInfo?: string;
  actions?: ReactNode;
  afterTitle?: ReactNode;
  className?: string;
}

export const UnifiedTopBar = memo(function UnifiedTopBar({
  subtitle,
  stepInfo,
  actions,
  afterTitle,
  className = '',
}: UnifiedTopBarProps) {
  return (
    <header
      className={`sticky top-0 z-50 bg-[#0a0f1f]/95 backdrop-blur-md border-b border-[#1a2d4d]/50 shadow-lg ${className}`}
    >
      <div className="flex items-center justify-between px-4 py-2.5">
        <div className="flex items-center">
          <img
            src="/images/WIA Logo.png"
            alt="Writing Interactive Academy Logo"
            className="h-8 w-8 mr-3"
          />
          <h1 className="text-lg font-bold text-white flex items-center">
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#4f46e5] to-[#06b6d4]">
              Interactive Flow Tool
            </span>
            {subtitle && <span className="text-gray-400 text-xs font-normal ml-2">{subtitle}</span>}
          </h1>
          {afterTitle && <div className="ml-4">{afterTitle}</div>}
        </div>
        <div className="flex items-center space-x-4">
          {stepInfo && (
            <div className="flex items-center space-x-1 text-xs">
              <span className="text-[#4f46e5]">●</span>
              <span className="text-gray-400">{stepInfo}</span>
            </div>
          )}
          {actions}
        </div>
      </div>
    </header>
  );
});
